// CountdownTimer.js
import React, { useEffect, useState } from "react";
import { Typography, Box } from "@mui/material";

const CountdownTimer = ({ initialSeconds, message }) => {
  const [timeLeft, setTimeLeft] = useState(initialSeconds);

  useEffect(() => {
    if (timeLeft <= 0) return;
    const timer = setInterval(() => {
      setTimeLeft((prev) => {
        if (prev <= 1) {
          clearInterval(timer);
          return 0;
        }
        return prev - 1;
      });
    }, 1000);
    return () => clearInterval(timer);
  }, [timeLeft]);

  const formatTime = (secs) => {
    const minutes = String(Math.floor(secs / 60)).padStart(2, "0");
    const seconds = String(secs % 60).padStart(2, "0");
    return `${minutes}:${seconds}`;
  };

  return (
    <Box
      sx={{
        borderRadius: 2,
        backgroundColor: timeLeft === 0 ? "error.main" : "primary.dark",
        color: "white",
        minWidth: 100,
        textAlign: "center",
        px: 2,
        py: 1,
      }}
    >
      <Typography variant="h6" fontWeight={500}>
        {timeLeft === 0
          ? "Time Up! Mantri Failed To Guess In Time."
          : `${message} : ${formatTime(timeLeft)}`}
      </Typography>
    </Box>
  );
};

export default CountdownTimer;
